import React from "react";
import ButtonAnimated from "../ButtonAnimated/ButtonAnimated";
import "./Ratgeber.css";
import Image from "next/image";
import carValueImage from "../../assets/auto-bewerten/wie-viel-ist-mein-auto-wert.avif";
import damageValueImage from "../../assets/auto-bewerten/unfallauto-wert2.avif";
import unfallwertMinderung from "../../assets/auto-bewerten/unfall-wertminderung.avif";
import wkdaAlternative from "@/assets/ratgeber/wirkaufendeinautoalternative.avif";
import kaputtesAuto from "@/assets/ratgeber/kaputtes-auto-verkaufen.avif";
import notverkauf from "@/assets/ratgeber/notverkauf.avif";
import motorSchaden from "@/assets/ratgeber/motorschaden.avif";
import autoVerkaufen from "@/assets/ratgeber/autoVerkaufen.webp";
import listenpreis from "@/assets/ratgeber/listenpreisrechner.avif";
import autoExport from "@/assets/ratgeber/auto-export.avif";
import tirol from "@/assets/ratgeber/tirol.avif";
import autoTauschen from "../../assets/auto-bewerten/auto-tausch.avif";
import finPruefung from "@/assets/fahrgestellnummer-pruefen/kostenlose-fin-ueberpruefung2.avif";
import Link from "next/link";

// Ratgeber items
const ratgeberItems = {
  autoVerkaufen: {
    image: autoVerkaufen,
    alt: "Auto verkaufen",
    title: "Auto Verkaufen",
    description:
      "Erfahre, wie du dein Auto schnell und einfach verkaufen kannst, und welche Schritte dir helfen, den besten Preis zu erzielen.",
    link: "/auto-verkaufen",
  },
  autoBewerten: {
    image: carValueImage,
    alt: "Wie bewerte ich mein Auto?",
    title: "Auto Bewerten",
    description:
      "Die Bewertung deines Autos ist der erste Schritt beim Verkauf. Erfahre, wie du den Wert deines Fahrzeugs basierend auf Marke, Modell und Zustand berechnen kannst.",
    link: "/auto-bewerten",
  },
  fahrgestellnummerPruefen: {
    image: damageValueImage,
    alt: "Wie bewerte ich mein Auto?",
    title: "Fahrgestellnummer prüfen",
    description:
      "Die Fahrgestellnummer bietet eine Vielzahl an wichtigen Daten zu deinem Fahrzeug. Sie hilft dabei, die Geschichte und den Zustand des Autos besser zu verstehen.",
    link: "/fahrgestellnummer-pruefen",
  },
  wirkaufendeinautoAlternative: {
    image: wkdaAlternative,
    alt: "Wirkaufendeinauto Alternative",
    title: "Wirkaufendeinauto Alternative",
    description:
      "Wenn du nach einer Alternative suchst, wo du einen besseren Preis für dein Auto bekommst, könnte Autoeinfachlos genau das Richtige für dich sein.",
    link: "/auto-verkaufen/ratgeber/wirkaufendeinauto-alternative",
  },
  listenpreisBerechnen: {
    image: listenpreis,
    alt: "Listenpreis von deinem Auto berechnen",
    title: "Listenpreis-Auto Rechner",
    description:
      "Berechne kostenlos den Listenpreis deines Autos in Österreich präzise und zuverlässig auf Basis aktueller Live-Daten aus dem Gebrauchtwagenmarkt.",
    link: "/auto-bewerten/listenpreis-auto",
  },
  wasIstDieFin: {
    image: finPruefung,
    alt: "Was ist die Fahrgestellnummer (FIN)?",
    title: "Was ist die Fahrgestellnummer (FIN)?",
    description:
      "Aufbau der 17 Stellen, wo die Nummer am Fahrzeug und im Zulassungsschein steht und was sie über dein Auto verrät.",
    link: "/fahrgestellnummer-pruefen/was-ist-die-fin",
  },
  kaputtesAuto: {
    image: kaputtesAuto,
    alt: "Kaputtes Auto verkaufen",
    title: "Kaputtes Auto verkaufen",
    description:
      "Auch ein kaputtes Auto hat einen Wert. Erfahre, wie du dein beschädigtes Fahrzeug richtig bewerten und erfolgreich verkaufen kannst.",
    link: "/kaputtes-auto-verkaufen",
  },
  autoVerkaufenTirol: {
    image: tirol,
    alt: "Auto verkaufen in Tirol",
    title: "Auto verkaufen in Tirol",
    description:
      "Erfahre, wie du dein Auto schnell und einfach in Tirol verkaufen kannst. Entdecke die besten Optionen und Tipps für den Verkauf in deiner Region.",
    link: "/auto-verkaufen/tirol",
  },

  autoExport: {
    image: autoExport,
    alt: "Autoexport",
    title: "Autoexport",
    description:
      "Erfahre, wie wir dir beim Autoexport helfen können und wie du einen besseren Verkaufspreis für dein Fahrzeug erzielen kannst.",
    link: "/auto-verkaufen/auto-export",
  },
  unfallAuto: {
    image: unfallwertMinderung,
    alt: "Unfallauto verkaufen",
    title: "Unfall Auto Verkaufen",
    description:
      "Ein Unfallauto hat oft noch Wert. Erfahre, wie du dein beschädigtes Fahrzeug schnell und fair verkaufen kannst.",
    link: "/kaputtes-auto-verkaufen/unfallauto-verkaufen",
  },
  autoMitMotorschaden: {
    image: motorSchaden,
    alt: "Auto mit motorschaden verkaufen",
    title: "Auto mit Motorschaden verkaufen",
    description:
      "Ein Auto mit Motorschaden hat noch Wert. Erfahre, wie du ein Fahrzeug mit defektem Motor erfolgreich verkaufen kannst.",
    link: "/kaputtes-auto-verkaufen/motorschaden-auto-verkaufen",
  },

  wasistmeinautowert: {
    image: autoTauschen,
    alt: "Was ist mein Auto wert?",
    title: "Was ist mein Auto wert? ",
    description:
      "Finde heraus, wie viel dein Auto wirklich wert ist. Erfahre, welche Faktoren den Preis deines Fahrzeugs beeinflussen.",
    link: "/auto-bewerten/ratgeber/was-ist-mein-auto-wert",
  },

  notVerkauf: {
    image: notverkauf,
    alt: "Notverkauf Auto",
    title: "Notverkauf",
    description:
      "Möchtest du dein Auto schnell verkaufen? Erfahre, wie du in einer Notlage den besten Preis für dein Fahrzeug erzielen kannst.",
    link: "/auto-verkaufen/notverkauf-auto",
  },
};

const Ratgeber = ({ title = "Ratgeber zum Autoverkauf", ...props }) => {
  // Filter the keys in props that are true and match with ratgeberItems
  const selectedItems = Object.keys(props)
    .filter((key) => props[key] && ratgeberItems[key])
    .map((key) => ratgeberItems[key]);

  return (
    <section className="Ratgeber">
      <h2 className="section-title Ratgeber-title">{title}</h2>
      <div className="Ratgeber-wrapper">
        {selectedItems.map((item, index) => (
          <Link key={index} className="Ratgeber-item" href={item.link}>
            <div className="Ratgeber-polygon"></div>
            <Image
              src={item.image}
              alt="Autoeinfachlos - Auto einfach online verkaufen"
              className="Ratgeber-image"
              width={300}
              height={200}
            />

            <div className="Ratgeber-text-wrapper">
              <span>{item.title}</span>
              <p className="non-anchor" aria-hidden="true">
                {item.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
      <ButtonAnimated
        text="Mehr lesen"
        fill="#fff"
        width="256px"
        height="48px"
        borderColor="transparent"
        backgroundColor="transparent"
        hoverBackgroundColor="#0000001a"
        color="#242424"
        hoverColor="#242424"
        fontSize="16px"
        link="/ratgeber"
      />
    </section>
  );
};

export default Ratgeber;
